DialogController = App.loadClass 'core::Angular/DialogController'

class exports.BaseController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @service) ->
        super(@scope, @transitions, @modalInstance)

        @scope.viewPrivacyPolicy = @viewPrivacyPolicy


    viewPrivacyPolicy: () =>
        @service.viewPrivacyPolicy()
